"use client";

import { useTranslations } from "next-intl";
import { useBoundStore } from "@/lib/stores/useBoundStore";
import { getEmeaEntity } from "@/lib/constants/emeaEntities";
import { LegalDocumentBody } from "../LegalDocumentBody";
import { lp, LegalPart } from "../helpers";

const PARTS: LegalPart[] = [
  lp.paragraph("intro"),
  lp.heading("section1Title"),
  lp.paragraph("section1Para1"),
  lp.paragraph("section1Para2"),
  lp.heading("section2Title"),
  lp.paragraph("section2Intro"),
  lp.list("section2List"),
  lp.heading("section3Title"),
  lp.paragraph("section3Intro"),
  lp.list("section3List"),
  lp.paragraph("section3Para2"),
  lp.paragraph("section3Para3"),
  lp.heading("section4Title"),
  lp.paragraph("section4Para1"),
  lp.heading("section5Title"),
  lp.paragraph("section5Para1"),
  lp.paragraph("section5Para2"),
  lp.paragraph("section5Para3"),
  lp.heading("section6Title"),
  lp.paragraph("section6Para1"),
  lp.paragraph("section6Para2"),
  lp.paragraph("section6Para3"),
  lp.heading("section7Title"),
  lp.paragraph("section7Para1"),
  lp.heading("section8Title"),
  lp.paragraph("section8Para1"),
  lp.paragraph("section8Para2"),
  lp.paragraph("section8Para3"),
  lp.paragraph("section8Para4"),
  lp.paragraph("section8Para5"),
  lp.heading("section9Title"),
  lp.list("section9List"),
  lp.heading("section10Title"),
  lp.paragraph("section10Para1"),
  lp.heading("section11Title"),
  lp.list("section11List"),
];

// EMEA Patient Terms of Use. Reused by the /legal page and the patient
// enrollment (AcceptTerms) flow. Entity is resolved from the detected country.
export function EMEAPatientTermsOfUseContent() {
  const userCountry = useBoundStore((state) => state.userCountry);
  const t = useTranslations("emeaPatientTOS");
  return (
    <LegalDocumentBody
      t={t}
      titleKey="title"
      parts={PARTS}
      entity={getEmeaEntity(userCountry)}
    />
  );
}
